// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"6d3d43c8","290":"2a137c6f","312":"2312bff0"}[chunkId] + ".chunk.js";
};